import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

//components
import Avatar from "react-avatar";
import { Dropdown } from "react-bootstrap";
import { Header, AvatarBox, LogoBox, ProfileBox } from "./styled";

//utils
import { MdOutlineCollectionsBookmark, MdOutlineSettings, MdPersonOutline, MdOutlineHelpOutline, MdOutlineLogout } from "react-icons/md";
import logoWhite from "../../../../../assets/img/logo-white-manager.svg";
import logoIcon from "../../../../../assets/img/logo-icon-white.svg";
import UsuarioContext from "../../../../../context/userContext/context";
import { colors } from "../../../../../theme/theme";
import useWindowDimensions from "../../../../../hooks/useWindowDimensions";

export const ManagerHeader = (props: any): JSX.Element => {
  const { showUserOptions, setShowUserOptions, showMenu, setShowMenu } = props;
  const { t: translation } = useTranslation();
  const history = useHistory();
  const { user } = useContext(UsuarioContext);
  const { width } = useWindowDimensions();

  const [usernameFormatted, setUsernameFormatted] = useState("");
  const [showLogoMobile, setShowLogoMobile] = useState(true);  

  const handleLogout = () => {
    history.push('/login');
  }
  
  useEffect(() => {
    let spliedtUsername = user.name.split(" ");

    setUsernameFormatted(spliedtUsername[0] + (spliedtUsername[1] ? " " + spliedtUsername[1] : ""))
  },[user])

  useEffect(() => {
    width > 750 ? setShowLogoMobile(false) : setShowLogoMobile(true);
  }, [width])

  return (
    <Header onClick={() => {if (width < 900) setShowMenu(false)}}>
      <LogoBox>
        <a href={user.is_superuser ? "/manager/admin/dashboard" : "/manager/partner/dashboard"}>
          <img src={showLogoMobile || !showMenu ? logoIcon : logoWhite} height={width > 900 ? (showLogoMobile || !showMenu ? "31" : "45") : "45"} style={{ padding: '3px', marginLeft: !showMenu ? '20px' : '30px' }} />
        </a>
      </LogoBox>

      <ProfileBox>
        <AvatarBox className={showUserOptions ? 'active': ''} onClick={() => setShowUserOptions(!showUserOptions)}>
          <span className="mr-2">{!showLogoMobile ? usernameFormatted : ""}</span>
          <Avatar size="33" round={true} name={user.name !== "" ? user.name : "U S"} src={user.picture ?? (user.name !== "" ? user.name : "U S")} color={!user.picture ? colors.mainColors.blueberry : ""} /> 
        </AvatarBox>
        <Dropdown.Menu show={showUserOptions} className="dropdownCustom">
            <Dropdown.Item onClick={() => {history.push('/home'); setShowUserOptions(false)}}>
              <span className="icon-user-options">
                <MdOutlineCollectionsBookmark/> <span className="font-16 ml-2">{translation('manager.menu.backDstore')}</span>
              </span>
            </Dropdown.Item>
            <Dropdown.Item onClick={() => {history.push('/manager/profile'); setShowUserOptions(false)}}>
              <span className="icon-user-options">
                <MdPersonOutline/> <span className="font-16 ml-2">{translation('manager.menu.account')}</span>
              </span>
            </Dropdown.Item>
            <Dropdown.Item>
              <span className="icon-user-options">
                <MdOutlineHelpOutline/> <span className="font-16 ml-2">{translation('manager.menu.help')}</span>
              </span>
            </Dropdown.Item>
            <Dropdown.Item onClick={() => handleLogout()}>
              <span className="icon-user-options">
                <MdOutlineLogout/> <span className="font-16 ml-2">{translation('manager.menu.logout')}</span>
              </span>
            </Dropdown.Item>
        </Dropdown.Menu>
      </ProfileBox>
    </Header>
  )
}